import { useMemo } from 'react';

const range = (start: number, end: number) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, i) => start + i);
};

export const usePagination = (
  totalPages: number,
  currentPage: number,
  siblingCount = 1, // How many page buttons to show on each side of the current pag
  boundaryCount = 1, // How many page buttons to show at the start and end
) =>
  useMemo(() => {
    const totalNumbers = siblingCount * 2 + boundaryCount * 2 + 3;
    const totalBlocks = totalNumbers + 2;

    if (totalPages <= totalBlocks) {
      return range(1, totalPages);
    }

    const startPages = range(1, boundaryCount);
    const endPages = range(totalPages - boundaryCount + 1, totalPages);

    const siblingsStart = Math.max(
      currentPage - siblingCount,
      boundaryCount + 1,
    );
    const siblingsEnd = Math.min(
      currentPage + siblingCount,
      totalPages - boundaryCount - 1,
    );

    const pages = [];

    pages.push(...startPages);

    if (siblingsStart > boundaryCount + 1) {
      pages.push('LEFT_ELLIPSIS');
    } else if (siblingsStart === boundaryCount) {
      pages.push(boundaryCount + 1);
    }

    pages.push(...range(siblingsStart, siblingsEnd));

    if (siblingsEnd < totalPages - boundaryCount - 1) {
      pages.push('RIGHT_ELLIPSIS');
    } else if (siblingsEnd === totalPages - boundaryCount - 1) {
      pages.push(totalPages - boundaryCount);
    }

    pages.push(...endPages);

    return pages;
  }, [totalPages, currentPage, siblingCount, boundaryCount]);
